import React from 'react';
import { TDR } from 'tdr-common';
import { InfoDialog } from './InfoDialog';
import { UnderlinedText } from '../../typography/UnderlinedText';
import styles from './TermsAndConditions.module.scss';
import { useTranslation } from 'react-i18next';

export const TermsAndConditions = () => {
	const { t } = useTranslation();
	const body = (
		<div className={styles.TermsPage}>
			<strong>{t('terms:background.title')}</strong>
			<p>{t('terms:background.paragraph1')}</p>
			<p>{t('terms:background.paragraph2')}</p>
			<p>{t('terms:background.paragraph3')}</p>

			<strong>{t('terms:license_grant.title')}</strong>
			<p>{t('terms:license_grant.paragraph')}</p>

			<strong>{t('terms:license_restrictions.title')}</strong>
			<p>{t('terms:license_restrictions.paragraph')}</p>

			<strong>{t('terms:consent_to_use_of_data.title')}</strong>
			<p>{t('terms:consent_to_use_of_data.paragraph')}</p>

			<strong>{t('terms:termination.title')}</strong>
			<p>{t('terms:termination.paragraph')}</p>

			<strong>{t('terms:reservation_of_rights.title')}</strong>
			<p>{t('terms:reservation_of_rights.paragraph')}</p>

			<strong>{t('terms:third_party_establishments.title')}</strong>
			<p>{t('terms:third_party_establishments.paragraph')}</p>

			<strong>{t('terms:payment_vendors.title')}</strong>
			<p>{t('terms:payment_vendors.paragraph')}</p>

			<strong>{t('terms:payment.title')}</strong>
			<p>{t('terms:payment.paragraph')}</p>

			<strong>{t('terms:refunds.title')}</strong>
			<p>{t('terms:refunds.paragraph')}</p>

			<strong>{t('terms:external_services.title')}</strong>
			<p>{t('terms:external_services.paragraph')}</p>

			<strong>{t('terms:no_warranty.title')}</strong>
			<p>{t('terms:no_warranty.paragraph')}</p>

			<strong>{t('terms:limitation_of_liability.title')}</strong>
			<p>{t('terms:limitation_of_liability.paragraph')}</p>

			<strong>{t('terms:maintenance.title')}</strong>
			<p>{t('terms:maintenance.paragraph')}</p>

			<strong>{t('terms:updates.title')}</strong>
			<p>{t('terms:updates.paragraph')}</p>

			<strong>{t('terms:communications.title')}</strong>
			<p>{t('terms:communications.paragraph')}</p>

			<strong>{t('terms:push_notifications.title')}</strong>
			<p>{t('terms:push_notifications.paragraph')}</p>

			<strong>{t('terms:disputes.title')}</strong>
			<p>{t('terms:disputes.paragraph')}</p>

			<strong>{t('terms:export_restrictions.title')}</strong>
			<p>{t('terms:export_restrictions.paragraph1')}</p>
			<p>{t('terms:export_restrictions.paragraph2')}</p>

			<strong>{t('terms:governing_law.title')}</strong>
			<p>{t('terms:governing_law.paragraph')}</p>

			<strong>{t('terms:general.title')}</strong>
			<p>{t('terms:general.paragraph')}</p>

			<strong>{t('terms:contact_us.title')}</strong>
			<p>{t('terms:contact_us.paragraph', { email: TDR.SUPPORT_EMAIL })}</p>
		</div>
	);

	return (
		<InfoDialog
			title={t('titles.terms_and_conditions')}
			body={body}
			triggerButton={<UnderlinedText>{t('titles.terms_and_conditions')}</UnderlinedText>}
		/>
	);
};


